import router from '@/router';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
export { canSetupNativePlugin } from './platform';
dayjs.extend(utc);
dayjs.extend(timezone);
export function toPage(
  path: string,
  replace = false,
  query = {},
  callback: (() => void) | null = null,
) {
  if (replace) {
    router
      .replace({
        path,
        query,
      })
      .then(() => {
        if (Object.prototype.toString.call(callback) === '[object Function]') {
          (callback as () => void)();
        }
      });
  } else {
    router
      .push({
        path,
        query,
      })
      .then(() => {
        if (Object.prototype.toString.call(callback) === '[object Function]') {
          (callback as () => void)();
        }
      });
  }
}

// 时区自动转换
export const formatToLocalTime = function (
  timestamp: number,
  format?: string,
): string {
  format = format || 'YYYY-MM-DD HH:mm:ss';
  // 判断是否为秒级时间戳，如果是，则转换为毫秒
  const ts = timestamp < 1e12 ? timestamp * 1000 : timestamp;
  // dayjs 默认用本地时区格式化
  return dayjs.utc(ts).tz(dayjs.tz.guess()).format(format);
  // return dayjs(val).tz(dayjs.tz.guess()).format(format)
};

// 格式化时间 -> 当年 → 29/07 17:56（不显示年份）非当年 → 29/07/2025 17:56（显示完整年月日）
export const formatTime = (time: string | number) => {
  const date = new Date(Number(time));
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const dateStr = `${day}/${month}`;
  const timeStr = `${hours}:${minutes}`;
  return year === new Date().getFullYear()
    ? `${dateStr} ${timeStr}`
    : `${dateStr}/${year} ${timeStr}`;
};


export { showLoading } from '@/components/loading';
